'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117 from "./presto.types$-Site-Realm$$anon$117.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteRealm$$anon$120(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SiteRealm$$anon$120 as $c_Lpresto_types$SiteRealm$$anon$120 };
$p = $c_Lpresto_types$SiteRealm$$anon$120.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteRealm$$anon$120;
/** @constructor */
function $h_Lpresto_types$SiteRealm$$anon$120() {
}
export { $h_Lpresto_types$SiteRealm$$anon$120 as $h_Lpresto_types$SiteRealm$$anon$120 };
$h_Lpresto_types$SiteRealm$$anon$120.prototype = $p;
$p.bN = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$SiteRealm$().cwA(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAU = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAU(t);
});
var $d_Lpresto_types$SiteRealm$$anon$120 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteRealm$$anon$120, "presto.types$SiteRealm$$anon$120", ({
  a1V: 1,
  K: 1
}));
export { $d_Lpresto_types$SiteRealm$$anon$120 as $d_Lpresto_types$SiteRealm$$anon$120 };
function $s_Lpresto_types$SiteRealm$__administrativo__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__administrativo;
}
export { $s_Lpresto_types$SiteRealm$__administrativo__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__administrativo__Lpresto_types$SiteRealm };
function $s_Lpresto_types$SiteRealm$__eleitoral__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__eleitoral;
}
export { $s_Lpresto_types$SiteRealm$__eleitoral__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__eleitoral__Lpresto_types$SiteRealm };
function $s_Lpresto_types$SiteRealm$__estadual__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__estadual;
}
export { $s_Lpresto_types$SiteRealm$__estadual__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__estadual__Lpresto_types$SiteRealm };
function $s_Lpresto_types$SiteRealm$__federal__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__federal;
}
export { $s_Lpresto_types$SiteRealm$__federal__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__federal__Lpresto_types$SiteRealm };
function $s_Lpresto_types$SiteRealm$__judicial__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__judicial;
}
export { $s_Lpresto_types$SiteRealm$__judicial__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__judicial__Lpresto_types$SiteRealm };
function $s_Lpresto_types$SiteRealm$__militar__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__militar;
}
export { $s_Lpresto_types$SiteRealm$__militar__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__militar__Lpresto_types$SiteRealm };
function $s_Lpresto_types$SiteRealm$__trabalhista__Lpresto_types$SiteRealm() {
  $m_Lpresto_types$SiteRealm$();
  return $t_Lpresto_types$SiteRealm$__trabalhista;
}
export { $s_Lpresto_types$SiteRealm$__trabalhista__Lpresto_types$SiteRealm as $s_Lpresto_types$SiteRealm$__trabalhista__Lpresto_types$SiteRealm };
/** @constructor */
function $c_Lpresto_types$SiteRealm$() {
  this.cbA = null;
  this.cbB = false;
  this.cby = null;
  this.cbz = false;
  this.cbC = null;
  this.cbD = false;
  this.cbE = null;
  this.cbF = false;
  $n_Lpresto_types$SiteRealm$ = this;
  $t_Lpresto_types$SiteRealm$__administrativo = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(0, "administrativo", this);
  $t_Lpresto_types$SiteRealm$__eleitoral = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(1, "eleitoral", this);
  $t_Lpresto_types$SiteRealm$__estadual = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(2, "estadual", this);
  $t_Lpresto_types$SiteRealm$__federal = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(3, "federal", this);
  $t_Lpresto_types$SiteRealm$__judicial = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(4, "judicial", this);
  $t_Lpresto_types$SiteRealm$__militar = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(5, "militar", this);
  $t_Lpresto_types$SiteRealm$__trabalhista = new $j_presto$002etypes$0024$002dSite$002dRealm$0024$0024anon$0024117.$c_Lpresto_types$SiteRealm$$anon$117(6, "trabalhista", this);
  $s_Lpresto_types$SiteRealm$__administrativo__Lpresto_types$SiteRealm();
  $s_Lpresto_types$SiteRealm$__eleitoral__Lpresto_types$SiteRealm();
  $s_Lpresto_types$SiteRealm$__estadual__Lpresto_types$SiteRealm();
  $s_Lpresto_types$SiteRealm$__federal__Lpresto_types$SiteRealm();
  $s_Lpresto_types$SiteRealm$__judicial__Lpresto_types$SiteRealm();
  $s_Lpresto_types$SiteRealm$__militar__Lpresto_types$SiteRealm();
  $s_Lpresto_types$SiteRealm$__trabalhista__Lpresto_types$SiteRealm();
}
export { $c_Lpresto_types$SiteRealm$ as $c_Lpresto_types$SiteRealm$ };
$p = $c_Lpresto_types$SiteRealm$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteRealm$;
/** @constructor */
function $h_Lpresto_types$SiteRealm$() {
}
export { $h_Lpresto_types$SiteRealm$ as $h_Lpresto_types$SiteRealm$ };
$h_Lpresto_types$SiteRealm$.prototype = $p;
$p.cwA = (function(\u03b4name) {
  switch (\u03b4name) {
    case "administrativo": {
      return $s_Lpresto_types$SiteRealm$__administrativo__Lpresto_types$SiteRealm();
      break;
    }
    case "eleitoral": {
      return $s_Lpresto_types$SiteRealm$__eleitoral__Lpresto_types$SiteRealm();
      break;
    }
    case "estadual": {
      return $s_Lpresto_types$SiteRealm$__estadual__Lpresto_types$SiteRealm();
      break;
    }
    case "federal": {
      return $s_Lpresto_types$SiteRealm$__federal__Lpresto_types$SiteRealm();
      break;
    }
    case "judicial": {
      return $s_Lpresto_types$SiteRealm$__judicial__Lpresto_types$SiteRealm();
      break;
    }
    case "militar": {
      return $s_Lpresto_types$SiteRealm$__militar__Lpresto_types$SiteRealm();
      break;
    }
    case "trabalhista": {
      return $s_Lpresto_types$SiteRealm$__trabalhista__Lpresto_types$SiteRealm();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.cIj = (function() {
  if ((!this.cbB)) {
    this.cbA = new $c_Lpresto_types$SiteRealm$$anon$118(this);
    this.cbB = true;
  }
  return this.cbA;
});
$p.iO = (function() {
  if ((!this.cbz)) {
    this.cby = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$SiteRealm$().cwA(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.cbz = true;
  }
  return this.cby;
});
$p.cIB = (function() {
  if ((!this.cbD)) {
    this.cbC = new $c_Lpresto_types$SiteRealm$$anon$119(this);
    this.cbD = true;
  }
  return this.cbC;
});
$p.GM = (function() {
  if ((!this.cbF)) {
    this.cbE = new $c_Lpresto_types$SiteRealm$$anon$120(this);
    this.cbF = true;
  }
  return this.cbE;
});
var $d_Lpresto_types$SiteRealm$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteRealm$, "presto.types$SiteRealm$", ({
  a1R: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$SiteRealm$ as $d_Lpresto_types$SiteRealm$ };
var $n_Lpresto_types$SiteRealm$;
function $m_Lpresto_types$SiteRealm$() {
  if ((!$n_Lpresto_types$SiteRealm$)) {
    $n_Lpresto_types$SiteRealm$ = new $c_Lpresto_types$SiteRealm$();
  }
  return $n_Lpresto_types$SiteRealm$;
}
export { $m_Lpresto_types$SiteRealm$ as $m_Lpresto_types$SiteRealm$ };
/** @constructor */
function $c_Lpresto_types$SiteRealm$$anon$118(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SiteRealm$$anon$118 as $c_Lpresto_types$SiteRealm$$anon$118 };
$p = $c_Lpresto_types$SiteRealm$$anon$118.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteRealm$$anon$118;
/** @constructor */
function $h_Lpresto_types$SiteRealm$$anon$118() {
}
export { $h_Lpresto_types$SiteRealm$$anon$118 as $h_Lpresto_types$SiteRealm$$anon$118 };
$h_Lpresto_types$SiteRealm$$anon$118.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$SiteRealm$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$SiteRealm$$anon$118 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteRealm$$anon$118, "presto.types$SiteRealm$$anon$118", ({
  a1T: 1,
  a: 1,
  k: 1
}));
export { $d_Lpresto_types$SiteRealm$$anon$118 as $d_Lpresto_types$SiteRealm$$anon$118 };
/** @constructor */
function $c_Lpresto_types$SiteRealm$$anon$119(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SiteRealm$$anon$119 as $c_Lpresto_types$SiteRealm$$anon$119 };
$p = $c_Lpresto_types$SiteRealm$$anon$119.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteRealm$$anon$119;
/** @constructor */
function $h_Lpresto_types$SiteRealm$$anon$119() {
}
export { $h_Lpresto_types$SiteRealm$$anon$119 as $h_Lpresto_types$SiteRealm$$anon$119 };
$h_Lpresto_types$SiteRealm$$anon$119.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$SiteRealm$();
  var x$1 = x.l();
  var that = y.l();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x$1, that);
});
var $d_Lpresto_types$SiteRealm$$anon$119 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteRealm$$anon$119, "presto.types$SiteRealm$$anon$119", ({
  a1U: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$SiteRealm$$anon$119 as $d_Lpresto_types$SiteRealm$$anon$119 };
var $t_Lpresto_types$SiteRealm$__administrativo = null;
function $u_Lpresto_types$SiteRealm$__administrativo(x) {
  $t_Lpresto_types$SiteRealm$__administrativo = x;
}
export { $t_Lpresto_types$SiteRealm$__administrativo as $t_Lpresto_types$SiteRealm$__administrativo, $u_Lpresto_types$SiteRealm$__administrativo as $u_Lpresto_types$SiteRealm$__administrativo };
var $t_Lpresto_types$SiteRealm$__eleitoral = null;
function $u_Lpresto_types$SiteRealm$__eleitoral(x) {
  $t_Lpresto_types$SiteRealm$__eleitoral = x;
}
export { $t_Lpresto_types$SiteRealm$__eleitoral as $t_Lpresto_types$SiteRealm$__eleitoral, $u_Lpresto_types$SiteRealm$__eleitoral as $u_Lpresto_types$SiteRealm$__eleitoral };
var $t_Lpresto_types$SiteRealm$__estadual = null;
function $u_Lpresto_types$SiteRealm$__estadual(x) {
  $t_Lpresto_types$SiteRealm$__estadual = x;
}
export { $t_Lpresto_types$SiteRealm$__estadual as $t_Lpresto_types$SiteRealm$__estadual, $u_Lpresto_types$SiteRealm$__estadual as $u_Lpresto_types$SiteRealm$__estadual };
var $t_Lpresto_types$SiteRealm$__federal = null;
function $u_Lpresto_types$SiteRealm$__federal(x) {
  $t_Lpresto_types$SiteRealm$__federal = x;
}
export { $t_Lpresto_types$SiteRealm$__federal as $t_Lpresto_types$SiteRealm$__federal, $u_Lpresto_types$SiteRealm$__federal as $u_Lpresto_types$SiteRealm$__federal };
var $t_Lpresto_types$SiteRealm$__judicial = null;
function $u_Lpresto_types$SiteRealm$__judicial(x) {
  $t_Lpresto_types$SiteRealm$__judicial = x;
}
export { $t_Lpresto_types$SiteRealm$__judicial as $t_Lpresto_types$SiteRealm$__judicial, $u_Lpresto_types$SiteRealm$__judicial as $u_Lpresto_types$SiteRealm$__judicial };
var $t_Lpresto_types$SiteRealm$__militar = null;
function $u_Lpresto_types$SiteRealm$__militar(x) {
  $t_Lpresto_types$SiteRealm$__militar = x;
}
export { $t_Lpresto_types$SiteRealm$__militar as $t_Lpresto_types$SiteRealm$__militar, $u_Lpresto_types$SiteRealm$__militar as $u_Lpresto_types$SiteRealm$__militar };
var $t_Lpresto_types$SiteRealm$__trabalhista = null;
function $u_Lpresto_types$SiteRealm$__trabalhista(x) {
  $t_Lpresto_types$SiteRealm$__trabalhista = x;
}
export { $t_Lpresto_types$SiteRealm$__trabalhista as $t_Lpresto_types$SiteRealm$__trabalhista, $u_Lpresto_types$SiteRealm$__trabalhista as $u_Lpresto_types$SiteRealm$__trabalhista };
//# sourceMappingURL=presto.types$-Site-Realm$.js.map
